import { inViewFade, inViewFadeUp } from '@helpers/animate';
import brand from '@helpers/brand';
import { baseGrid } from '@helpers/grid';
import { imageCoverContainer } from '@helpers/image';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h3, micro } from '@helpers/typography';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import { mix } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  background: var(--bgColor);
  color: var(--fgColor);
  padding: var(--sectionSpacing) 0;

  &[data-bg='white'] {
    --bgColor: ${brand.white};
    --fgColor: ${brand.black};
  }

  &[data-bg='lightGrey'] {
    --bgColor: ${mix(0.25, brand.grey.otherGrey, brand.white)};
    --fgColor: ${brand.black};
  }

  &[data-bg='grey'] {
    --bgColor: ${brand.grey.grey3};
    --fgColor: ${brand.black};
  }

  &[data-bg='black'] {
    --bgColor: ${brand.grey.grey6};
    --fgColor: ${brand.black};
  }
`;
const Inner = styled.div `
  ${baseGrid};
  background: ${brand.white};
  width: 100%;
`;
const ImageWrapper = styled.figure `
  position: relative;

  @media ${until(Device.TabletLarge)} {
    grid-column: 1 / span 12;
  }

  @media ${from(Device.TabletLarge)} {
    grid-row: 1;
    width: calc(100% + var(--gutterWidth));

    [data-layout='imageLeft'] & {
      grid-column: 1 / span 7;
      justify-self: flex-start;
    }

    [data-layout='imageRight'] & {
      grid-column: -8 / span 7;
      justify-self: flex-end;
    }

    [data-layout='imageLeft'][data-split='50/50'] & {
      grid-column: 1 / span 6;
    }

    [data-layout='imageRight'][data-split='50/50'] & {
      grid-column: 7 / span 6;
      width: calc(100% + (var(--gutterWidth) / 2));
    }

    [data-layout='imageLeft'][data-split='33/66'] & {
      grid-column: 1 / span 5;
    }

    [data-layout='imageRight'][data-split='33/66'] & {
      grid-column: -5 / span 5;
    }
  }

  ${inViewFade({ delay: 0, duration: 0.6 })};
`;
const Image = styled(SimpleImage) `
  ${imageCoverContainer(true)}
`;
const ImageCaption = styled.figcaption `
  ${micro}

  position: absolute;
  bottom: 0;
  left: 0;
  display: block;
  background: ${brand.white};
  margin: 0;
  max-width: 100%;
  overflow: hidden;
  padding: 4px 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const ContentWrapper = styled.div `
  display: flex;
  flex-direction: column;

  @media ${until(Device.TabletLarge)} {
    grid-column: 1 / span 12;
    padding: 34px 28px;
  }

  @media ${from(Device.TabletLarge)} {
    align-items: center;
    grid-row: 1;
    justify-content: center;
    padding: 48px 0;

    [data-layout='imageLeft'] & {
      grid-column: -6 / span 5;
    }

    [data-layout='imageRight'] & {
      grid-column: 1 / span 5;
    }

    [data-layout='imageLeft'][data-split='50/50'] & {
      grid-column: -7 / span 7;
    }

    [data-layout='imageRight'][data-split='50/50'] & {
      grid-column: 1 / span 6;
      width: calc(100% + (var(--gutterWidth) / 2));
    }

    [data-layout='imageLeft'][data-split='33/66'] & {
      grid-column: -7 / span 7;
    }

    [data-layout='imageRight'][data-split='33/66'] & {
      grid-column: 1 / span 8;
    }
  }
`;
const ContentWrapperInner = styled.div `
  @media ${from(Device.TabletLarge)} {
    max-width: 353px;

    [data-split='50/50'] & {
      max-width: 525px;
    }

    [data-split='33/66'] & {
      max-width: 767px;
    }
  }
`;
const Title = styled.h2 `
  ${h3};
  position: relative;
  padding-bottom: 26px;
  margin-bottom: 24px;

  @media ${from(Device.TabletLarge)} {
    padding-bottom: 35px;
    margin-bottom: 48px;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    background: ${brand.black};
    height: 4px;
    width: 94px;
  }

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const Content = styled.div `
  ${contentStyles};

  ${inViewFadeUp({ delay: 0.15, duration: 0.3 })};
`;
const CtaWrapper = styled.div `
  margin-top: 32px;

  @media ${from(Device.TabletLarge)} {
    margin-top: 50px;
  }

  ${inViewFadeUp({ delay: 0.3, duration: 0.3 })};
`;
const SplitContentStyles = {
    Container,
    Content,
    ContentWrapper,
    ContentWrapperInner,
    CtaWrapper,
    Image,
    ImageCaption,
    ImageWrapper,
    Inner,
    Title,
};
export default SplitContentStyles;
